import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ThemeService } from '../../_helpers/theming-engine/theme.service';
import { StudentMaintenanceService } from '../../_services/student-maintenance/student-maintenance.service';
import { UploadAddModalComponent } from './upload-add-modal/upload-add-modal.component';
import { ManualAddModalComponent } from './manual-add-modal/manual-add-modal.component';
import { Router } from '@angular/router';
import { FeatureHelperService } from '../../_helpers/feature-helper/feature-helper.service';
import { AuthenticationStateHelperService } from '../../_helpers/authentication-state-helper/authentication-state-helper.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'add-student',
    templateUrl: './add-student.component.html',
    styleUrls: ['./add-student.component.css'],
    standalone: false
})
export class AddStudentComponent implements OnInit, OnDestroy {
  @ViewChild('uploadButton', { static: false }) uploadButton: ElementRef;
  @ViewChild('manualButton', { static: false }) manualButton: ElementRef;
  
  
  constructor(
    public themeService: ThemeService,
    private studentMaintenanceService: StudentMaintenanceService,
    public dialog: MatDialog,
    public router: Router,
    private featureHelperService: FeatureHelperService,
    private authenticationStateHelper: AuthenticationStateHelperService
  ) {}
  
  ngOnDestroy(): void {}

  ngOnInit() {
    
    let featureList = new Array<string>();
    featureList.push("StudentDataInsert");

    let currentUserFeatures = this.featureHelperService.checkFeaturePermissions(featureList);

    if (!currentUserFeatures.filter(f => f.feature === "StudentDataInsert")[0].enabled) {
      console.error("User does not have the required permissions to view the student add screen");
      this.router.navigate(['/login'], { queryParams: { returnUrl: window.location.pathname }});
      this.authenticationStateHelper.unauthorizedToken = true;
    }

  }

  public setMode(mode: string): void {

    if (mode == 'Upload') {
      if (!this.uploadButton.nativeElement.classList.contains("active")) {
        this.uploadButton.nativeElement.classList.add("active")
      }
      if (this.manualButton.nativeElement.classList.contains("active")) {
        this.manualButton.nativeElement.classList.remove("active")
      }
      
      const dialogRef = this.dialog.open(UploadAddModalComponent, {
      panelClass: 'my-dialog'
      });

    } else {
      if (this.uploadButton.nativeElement.classList.contains("active")) {
        this.uploadButton.nativeElement.classList.remove("active")
      }
      if (!this.manualButton.nativeElement.classList.contains("active")) {
        this.manualButton.nativeElement.classList.add("active")
      }
      
      this.studentMaintenanceService.studentId = 0;
      const dialogRef = this.dialog.open(ManualAddModalComponent, {
        panelClass: 'my-dialog'
      });
    }
  }

}
